import { render, staticRenderFns } from "./PolicyTransactions.vue?vue&type=template&id=5169a65e"
import script from "./PolicyTransactions.vue?vue&type=script&lang=js"
export * from "./PolicyTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports